import axios from 'axios'
import { API_BASE_PATH } from '../Config/Config'
import {useMutation} from '@tanstack/react-query'

const addAppDetails = async (data) => {
     const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);


  const response = await axios.post(`${API_BASE_PATH}/KeyLogging/addProduct`, data)
  return response
}

const useAddAppDetails = (options = {}) => {
    return useMutation({
        mutationFn: addAppDetails,
        ...options
    })
}
export default useAddAppDetails;